import React, { FC } from "react";
import { ISectionCTA } from "./ISectionCTA";
import { MovableSectionCTA as Movable } from "./MovableSectionCTA/MovableSectionCTA";
import { SimpleSectionCTA as Simple } from "./SimpleSectionCTA/SimpleSectionCTA";

const SectionCTA: FC<ISectionCTA.IProps> = (props) => {
  return props.canDragDrop ? (
    <Movable {...props} /> // being used for adding draggable section element
  ) : (
    <Simple {...props} /> // being used for normal section element
  );
};

export default SectionCTA;
